import {
  SESSAO_INVALIDA_COOKIE,
  SESSAO_INVALIDA_COOKIE_SEGURO,
} from '@/shared/constants/authCookies';

const SESSAO_INVALIDA_MAX_AGE_SEGUNDOS = 5 * 60;

const EXPIRACAO_NO_PASSADO = 'path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

const conexaoSegura = (): boolean => window.location.protocol === 'https:';

/**
 * Grava a marca que o `proxy` no edge (`src/proxy.ts`) lê para saber que a sessão
 * corrente já foi recusada — os cookies httpOnly de sessão sobrevivem à revogação
 * server-side, então a presença deles não prova sessão viva. Sob https usa o
 * prefixo `__Host-`, que proíbe `Domain` e impede um subdomínio de forjar a marca.
 */
export const marcarSessaoInvalida = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const atributos = `path=/; max-age=${SESSAO_INVALIDA_MAX_AGE_SEGUNDOS}; SameSite=Lax`;

  if (conexaoSegura()) {
    document.cookie = `${SESSAO_INVALIDA_COOKIE_SEGURO}=1; ${atributos}; Secure`;
    return;
  }

  document.cookie = `${SESSAO_INVALIDA_COOKIE}=1; ${atributos}`;
};

export const limparMarcaSessaoInvalida = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${SESSAO_INVALIDA_COOKIE}=; ${EXPIRACAO_NO_PASSADO}`;

  if (conexaoSegura()) {
    document.cookie = `${SESSAO_INVALIDA_COOKIE_SEGURO}=; ${EXPIRACAO_NO_PASSADO}; Secure`;
  }
};

export const removeLegacyAuthCookie = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const domains = new Set<string>(['']);
  const hostname = window.location.hostname;

  if (!hostname.includes('localhost')) {
    domains.add(hostname);

    const parts = hostname.split('.');
    if (parts.length >= 2) {
      domains.add(`.${parts.slice(-2).join('.')}`);
    }
  }

  domains.forEach((domain) => {
    const domainSegment = domain ? `; domain=${domain}` : '';
    document.cookie = `arbitrallis_auth=; ${EXPIRACAO_NO_PASSADO}${domainSegment}`;
  });
};
